<template>
  <div class="portlet">
    <titulo-pagina :line="dadosconteudo"></titulo-pagina>

    <filtro
      :line="dadosconteudo.tipotable"
      v-if="dadosconteudo.tipofiltro == 'filtronormal' && quantidade != ' (0)'"
    ></filtro>
    <filtro-data
      :line="dadosconteudo.tipotable"
      v-if="dadosconteudo.tipofiltro == 'filtrodata' && quantidade != ' (0)'"
    ></filtro-data>
    <filtro-entidade
      :line="dadosconteudo.tipotable"
      v-if="
        dadosconteudo.tipofiltro == 'filtroentidade' && quantidade != ' (0)'
      "
    ></filtro-entidade>
    <filtro-despesas
      :line="dadosconteudo.tipotable"
      v-if="
        dadosconteudo.tipofiltro == 'filtrodespesas' && quantidade != ' (0)'
      "
    ></filtro-despesas>
    <filtro-receita
      :line="dadosconteudo.tipotable"
      v-if="dadosconteudo.tipofiltro == 'filtroreceita' && quantidade != ' (0)'"
    ></filtro-receita>
    <filtro-contrato
      :line="dadosconteudo.tipotable"
      v-if="
        dadosconteudo.tipofiltro == 'filtrocontrato' && quantidade != ' (0)'
      "
    ></filtro-contrato>
    <conteudo-texto
      :line="dadosconteudo"
      v-if="dadosconteudo.tipotable == 'semtable' && quantidade != ' (0)'"
    ></conteudo-texto>
    <sem-conteudo
      :line="semregitro"
      v-if="dadosconteudo.tipotable != 'semtable' && quantidade == ' (0)'"
    ></sem-conteudo>

    <!--<filtro-geral :dados="dadosconteudo"></filtro-geral>-->
  </div>
  <!-- END FORM-->
</template>
<script>
import Filtro from "../../components/filtros/filtro1/filtro.vue";
import FiltroData from "../../components/filtros/filtro2/filtro2.vue";
import FiltroEntidade from "../../components/filtros/filtro3/filtro3.vue";
import FiltroDespesas from "../../components/filtros/filtro4/filtro4.vue";
import FiltroReceita from "../../components/filtros/filtro5/filtro5.vue";
import FiltroContrato from "../../components/filtros/filtro6/filtro6.vue";

import FiltroGeral from "../../components/filtros/filtrogeral/filtrogeral.vue";

import ConteudoTexto from "../../components/semtable/conteudotexto.vue";
import SemConteudo from "../../components/semtable/conteudotexto.vue";
import TituloPagina from "../../components/titulopagina.vue";

export default {
  data() {
    return {
      dadosconteudo: {},
      pesquisa: {},
      quantidade: "",
      semregitro: {
        conteudo: '<p class="text-semconteudo"> Não há dados cadastrados! </p>',
      },
    };
  },
  components: {
    Filtro,
    FiltroData,
    TituloPagina,
    FiltroEntidade,
    ConteudoTexto,
    FiltroDespesas,
    FiltroReceita,
    FiltroContrato,
    FiltroGeral,
    SemConteudo,
  },
  computed: {
    // criação da função que pega os dados da rota ativa
    dadosrouter: function () {
      //return `${this.$store.state.data.titulo}`
      return this.$route.param;
    },
  },
  ready() {
    // console.log($('.v-link-active span.title').html());
  },
  route: {
    data() {
      $.ajaxSetup({
        async: false,
      });

      var self = this;

      var urlAtual = window.location.href.split("/");
      var covid = false;

      for (var c = 0; c < urlAtual.length; c++) {
        if (urlAtual[c] == "covid") {
          covid = true;
        }
      }

      var options = {
        covid: covid,
      };
      if (this.$route.params.valor == null) {
        $.getJSON("./server/paginainicial.php", options, function (links) {
          self.dadosconteudo = links[0];
          //console.log(self.dadosconteudo)
        });
      }

      //json com os dados do menu
      if (this.$route.params.tipo == "legislacao") {
        //$.getJSON('./src/modules/conteudo/dataconteudo.json'+this.$route.params.valor, function(links)
        $.getJSON("./src/modules/conteudo/dataconteudo.json", function (links) {
          var titulo = JSON.search(
            window.menuJson,
            '//*[href="/' +
              self.$route.params.tipo +
              "/" +
              self.$route.params.valor +
              '"]/breadcrumb'
          );
          self.quantidade = JSON.search(
            window.menuJson,
            '//*[href="/' +
              self.$route.params.tipo +
              "/" +
              self.$route.params.valor +
              '"]/quantidade'
          );
          links[0].titulopagina = titulo;
          self.dadosconteudo = links[0];
          MPL.loadSelectsLegislacao();
        });
      }

      if (this.$route.params.tipo == "licitacao") {
        $.getJSON(
          "./src/modules/conteudo/dataconteudo2.json",
          function (links) {
            var titulo = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/breadcrumb'
            );
            self.quantidade = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/quantidade'
            );
            links[0].titulopagina = titulo;
            self.dadosconteudo = links[0];
            MPL.loadSelectsLicitacao();
          }
        );
      }

      if (
        this.$route.params.tipo == "tabela" &&
        this.$route.params.valor == "diario"
      ) {
        $.getJSON(
          "./src/modules/conteudo/dataconteudo3.json",
          function (links) {
            var titulo = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/breadcrumb'
            );
            self.quantidade = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/quantidade'
            );
            links[0].titulopagina = titulo;
            self.dadosconteudo = links[0];
            //console.log(self.dadosconteudo)
          }
        );
      }

      if (
        this.$route.params.tipo == "tabela" &&
        this.$route.params.valor == "despesas"
      ) {
        $.getJSON(
          "./src/modules/conteudo/dataconteudo4.json",
          function (links) {
            var titulo = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/breadcrumb'
            );
            self.quantidade = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/quantidade'
            );
            links[0].titulopagina = titulo;
            self.dadosconteudo = links[0];
            //MPL.loadSelectsDespesa();
          }
        );
      }

      if (
        this.$route.params.tipo == "tabela" &&
        this.$route.params.valor == "receitas"
      ) {
        $.getJSON(
          "./src/modules/conteudo/dataconteudo5.json",
          function (links) {
            var titulo = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/breadcrumb'
            );
            self.quantidade = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/quantidade'
            );
            links[0].titulopagina = titulo;
            self.dadosconteudo = links[0];
            //console.log(self.dadosconteudo)
          }
        );
      }

      if (
        this.$route.params.tipo == "tabela" &&
        this.$route.params.valor == "contratos"
      ) {
        $.getJSON(
          "./src/modules/conteudo/dataconteudo9.json",
          function (links) {
            var titulo = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/breadcrumb'
            );
            self.quantidade = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/quantidade'
            );
            links[0].titulopagina = titulo;
            self.dadosconteudo = links[0];
            //console.log(self.dadosconteudo)
          }
        );
      }

      if (this.$route.params.tipo == "pagina") {
        self.quantidade = " (1)";
        //$.getJSON('./src/modules/conteudo/dataconteudo6.json'+this.$route.params.valor, function(links)
        $.getJSON(
          "./server/pagina.php?v=" + this.$route.params.valor,
          options,
          function (links) {
            self.dadosconteudo = links[0];
            //console.log(self.dadosconteudo)
          }
        );
      }

      if (
        this.$route.params.tipo == "tabela" &&
        this.$route.params.valor == "diarias"
      ) {
        $.getJSON(
          "./src/modules/conteudo/dataconteudo7.json",
          function (links) {
            var titulo = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/breadcrumb'
            );
            self.quantidade = JSON.search(
              window.menuJson,
              '//*[href="/' +
                self.$route.params.tipo +
                "/" +
                self.$route.params.valor +
                '"]/quantidade'
            );
            links[0].titulopagina = titulo;
            self.dadosconteudo = links[0];
            //console.log(self.dadosconteudo)
          }
        );
      }

      $.ajaxSetup({
        async: true,
      });
      window.dadosconteudogeral = self.dadosconteudo;
    },
  },
};
</script>
<style>
.text-semconteudo {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// conteudo.vue?56f46824